/**
 * Iterates over select input elements in the given component
 * and returns an object with the current selections.
 * @param {Element} component
 * @returns {Object}
 */
const getSelectionData = (component) => (
    $(component).find('input').get().reduce((obj, input) => {
        const field = $(input).closest('fieldset').attr('name');

        if (input.checked) {
            return {
                ...obj,
                [field]: obj[field]
                    ? obj[field].concat(input.value)
                    : [input.value],
            };
        }

        return obj;
    }, {})
);

export default getSelectionData;



// WEBPACK FOOTER //
// ./src/scripts/components/common/getSelectionData.js